'use client';;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:tillamook-com":true});}catch(e){}}();

import React, { useState } from 'react';

import PropTypes from 'prop-types';

import Logo from 'components/globals/Logo';

import Button from 'components/ui/Button';
import Link from 'components/ui/Link';
import Text from 'components/ui/Text';

import FooterLinkGroup from './FooterLinkGroup';
import FooterShreds from './FooterShreds';
import FooterSignUp from './FooterSignUp';

import styles from './Footer.module.scss';

const signUpHeadline = 'Subscribe for more deliciousness';
const signUpCopy =
    'Tillamook email keeps you in the loop on all our special releases, discounts, best recipes and more.';

const Footer = ({
    socialMedia,
    footerRouteGroups,
    currentYear = '2025',
    privacyLink,
    termsLink,
    caSupplyChainsActLink,
}) => {
    const [mobileOpenIndex, setMobileOpenIndex] = useState(-1);

    const handleClick = index => {
        setMobileOpenIndex(index === mobileOpenIndex ? -1 : index);
    };

    return (
        <footer className={styles.root}>
            <section className={styles.signUp}>
                <FooterSignUp
                    headline={signUpHeadline}
                    copy={signUpCopy}
                    socialMedia={socialMedia}
                />
            </section>
            <section className={styles.logoAndLinkGroups}>
                <Link href="/" className={styles.logoLink}>
                    <span className="sr-only">Home Page</span>
                    <Logo withMorningStar className={styles.logo} />
                    <p className={styles.tagline}>
                        Extraordinary
                        <br />
                        <span>
                            Dairy<sup>&reg;</sup>
                        </span>
                    </p>
                </Link>
                <div className={styles.linkGroups}>
                    {footerRouteGroups?.length > 0 &&
                        footerRouteGroups.map((group, i) => {
                            return (
                                <FooterLinkGroup
                                    key={i}
                                    index={i}
                                    headline={group.headline}
                                    routes={group.routesCollection.items}
                                    isMobileOpen={mobileOpenIndex === i}
                                    onClick={handleClick}
                                />
                            );
                        })}
                </div>
            </section>
            <section className={styles.legal}>
                <Link
                    title="Tillamook - Commitment to Care™"
                    href="/stewardship"
                    className={styles.ctc}
                >
                    <img
                        className={styles.ctcLogo}
                        src="/images/commitment-to-care.svg"
                        alt="Tillamook - Commitment to Care™ Logo"
                        loading="lazy"
                    />
                    <Text
                        baseTheme="labelSmallAlt"
                        themes={{
                            large: 'labelMediumAlt',
                        }}
                        className={styles.ctcInfo}
                    >
                        We’re committed to doing right by our people, cows and
                        land. <span className={styles.ctcLink}>Learn more</span>
                        .
                    </Text>
                </Link>
                <div className={styles.copyrightAndLegal}>
                    <Text
                        as="div"
                        className={styles.copyrightWithLegalLinks}
                        baseTheme="bodyXSmall"
                    >
                        <div className={styles.copyright}>
                            © {currentYear} Tillamook County Creamery
                            Association. All rights reserved.
                        </div>
                        <div className={styles.legalLinks}>
                            {privacyLink && (
                                <Link
                                    href={privacyLink?.link?.href}
                                    as={`/${privacyLink?.link?.as}`}
                                    className={styles.legalLink}
                                >
                                    {privacyLink?.text}
                                </Link>
                            )}
                            {termsLink && (
                                <Link
                                    href={termsLink?.link?.href}
                                    as={`/${termsLink?.link?.as}`}
                                    className={styles.legalLink}
                                >
                                    {termsLink?.text}
                                </Link>
                            )}
                            {caSupplyChainsActLink && (
                                <Link
                                    href={caSupplyChainsActLink?.link?.href}
                                    as={`/${caSupplyChainsActLink?.link?.as}`}
                                    className={styles.legalLink}
                                >
                                    {caSupplyChainsActLink?.text}
                                </Link>
                            )}
                        </div>
                    </Text>
                    <Text
                        as="div"
                        className={styles.privacyPreferences}
                        baseTheme="bodyXSmall"
                    >
                        <Button
                            theme="none"
                            className={styles.legalLink}
                            onClick={() => {
                                window.OneTrust.ToggleInfoDisplay();
                            }}
                        >
                            Manage Privacy Preferences
                        </Button>
                    </Text>
                    <Text
                        as="p"
                        id="rBST"
                        baseTheme="bodyXSmall"
                        className={styles.disclaimer}
                    >
                        *All farmers who supply milk for Tillamook products
                        pledge to not use artificial growth hormones. The FDA
                        has stated that no significant difference has been shown
                        between milk derived from rBST treated and non-rBST
                        treated cows.
                    </Text>
                </div>
            </section>

            <FooterShreds mobileOpenIndex={mobileOpenIndex} />
        </footer>
    );
};

Footer.propTypes = {
    socialMedia: PropTypes.array,
    footerRouteGroups: PropTypes.array.isRequired,
    privacyLink: PropTypes.object.isRequired,
    termsLink: PropTypes.object.isRequired,
    caSupplyChainsActLink: PropTypes.object.isRequired,
};

export default Footer;
